import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
export const useBillingControlData = function useBillingControlData(relationshipId) {
    let { refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { t: globalBillModalTexts } = useLocaleKeys('components.globalBillModal');
    const { data, isLoading } = useQueryState({
        queryKey: [
            QueryKeys.BillingControlData,
            relationshipId
        ],
        queryFn: ()=>api.relationship.getBillingControlData(relationshipId),
        enabled: !!relationshipId,
        refreshOnHookMount,
        toasts: {
            errorMessage: globalBillModalTexts.failedToLoadServices(),
            errorTestId: 'global-bill-failed-to-fetch'
        }
    });
    return {
        billingControlData: data,
        isLoading
    };
};
